import { render } from "./SupplierDetailOverviewTab.vue?vue&type=template&id=a90817c8"
import script from "./SupplierDetailOverviewTab.vue?vue&type=script&lang=js"
export * from "./SupplierDetailOverviewTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__